import dayjs, { type Dayjs } from "dayjs";

import type { ITransaction, ITransactionDto, TransactionState } from ".";

export class Transaction implements ITransaction
{

    advertiserName: string;
    campaignName: string;
    category?: string;
    title: string;
    description?: string;
    logo?: string;
    state: TransactionState;
    transactionDate?: Dayjs;
    stateName?: string;
    cashbackAmount?: number;
    purchaseAmount: number;

    constructor( model: ITransactionDto )
    {
        this.advertiserName = model.advertiserName;
        this.campaignName = model.advertiserName;
        this.title = model.title;
        this.category = model.category;
        this.description = model.description;
        this.logo = model.logo;
        this.state = model.state;
        this.transactionDate = dayjs( model.transactionDate );
        this.stateName = model.stateName;
        this.cashbackAmount = model.cashbackAmount;
        this.purchaseAmount = model.purchaseAmount;
    }

}